import { render, staticRenderFns } from "./ReportFilteringSelectionCard.vue?vue&type=template&id=f5722b08&scoped=true"
import script from "./ReportFilteringSelectionCard.vue?vue&type=script&lang=ts"
export * from "./ReportFilteringSelectionCard.vue?vue&type=script&lang=ts"
import style0 from "./ReportFilteringSelectionCard.vue?vue&type=style&index=0&id=f5722b08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5722b08",
  null
  
)

export default component.exports